<div class="full bg-background">
  <app-operation-segment-spec-detail
    class="flex"
    [operationSegmentSpec]="copy"
    (close)="onClose($event)"
    (save)="onSave($event)"
  >
  </app-operation-segment-spec-detail>
</div>
